import { gql, MutationResult, useMutation } from '@apollo/client';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useCallback } from 'react';
import { MAYA_GRAPHQL_ENDPOINT } from 'basics/constants/common.constants';
import { errorToast } from 'basics/utils/toast';
import { extractApolloErrorDetails } from 'services/graphql/extractApolloErrorDetails';
import Logger from 'services/logger';

export const setCepStatusToApprovedMutationCall = gql`
  mutation setCepStatusToApproved($id: String!, $sendToVeeva: Boolean!) {
      setCepStatusToApproved(id: $id, sendToVeeva: $sendToVeeva)
  }
`;

type ResultType = {
  setCepStatusToApproved: boolean;
};

type UseSetCepStatusToApprovedMutation = [
  (id: string) => Promise<boolean>,
  MutationResult<ResultType>,
];

export const useSetCepStatusToApprovedMutation = (): UseSetCepStatusToApprovedMutation => {
  const [setCepStatusToApproved, state] = useMutation<ResultType>(setCepStatusToApprovedMutationCall, {
    fetchPolicy: 'network-only',
    context: { clientName: MAYA_GRAPHQL_ENDPOINT },
  });
  const flags = useFlags();

  const executeMutation = useCallback(async (id) => {
    try {
      const { data } = await setCepStatusToApproved({
        variables: {
          id,
          sendToVeeva: flags.mayaEnableVeevaBiogenlinc1816,
        },
      });
      return data?.setCepStatusToApproved || false;
    } catch (error: unknown) {
      if (error instanceof Error) {
        const customContext = extractApolloErrorDetails(error);
        Logger.logError({
          error,
          customContext,
          transactionName: 'setCepStatusToApproved.ts - useSetCepStatusToAppoveMutation',
        });

        errorToast(error.message);
      }
      return false;
    }
  }, [setCepStatusToApproved, flags.mayaEnableVeevaBiogenlinc1816]);

  return [executeMutation, state];
};
